class PreOrderInput extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", function () {
      // Calculate tomorrow's day index
      const today = new Date();
      const maxDate = new Date(today); 
      // Tommorow
      maxDate.setDate(today.getDate() + 1);
      // Initialize Air Datepicker with dynamic first day
      if (typeof AirDatepicker === "function") {
        new AirDatepicker('#date-picker', {
          locale: {
            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            daysMin:  ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            months: ['January', 'February', 'March', 'April', 'May', 'June', 
                     'July', 'August', 'September', 'October', 'November', 'December'],
            monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            today: 'Today',
            clear: 'Clear',
            dateFormat: 'yyyy-MM-dd'
          },
          isMobile: true,
          minDate: maxDate,
          autoClose: true,
          onSelect: ({ date, formattedDate }) => {
            console.log('date', date, 'formattedDate', formattedDate);
            const preOrderCheckoutButton = document.getElementById('PreOrderCheckoutButton');
    
            // submit form if can not find button
            if(!preOrderCheckoutButton) {
              document.querySelector('[action="/cart"]')?.submit();
              return;
            }
    
            // enable checkout button
            preOrderCheckoutButton.removeAttribute('disabled');
            
            // update value pre_order_date
            [...document.querySelectorAll('[data-pre-order-date]')].forEach(element => {
              element.value = formattedDate;
            })
          }
        });
        console.log("AirDatepicker initialized with first day as tomorrow.");
      } else {
        console.error("AirDatepicker is not loaded.");
      }
      document.querySelector('#PreOrderButton').addEventListener('click', function() {
        document.querySelector('pre-order-input').style.display = 'none';
      });
      if(document.querySelector('#date-picker')?.value && new Date(document.querySelector('#date-picker')?.value) > new Date()) {
        document.querySelector('#PreOrderCheckoutButton').removeAttribute('disabled');
      }
    });
  }

}

customElements.define('pre-order-input', PreOrderInput);

document.addEventListener('click', function(e) {
  console.log('do pre-order checking....')
  console.log('target id:', e.target.id)
  // return if element is not checkout button
  if(e.target.id !== 'CartDrawer-Checkout' && e.target.id !== 'checkout') return;

  // find cart items has-pre-order-data

  const cartItems = document.querySelector(e.target.id == 'CartDrawer-Checkout' ? 'cart-drawer-items' : 'cart-items .cart-items');

  // stop if cart items node is not existed.
  if(!cartItems) return;
  const hasPreOrder = cartItems.dataset.preOrder;

  if(hasPreOrder == "true") {
    console.log('====== Prevent Checkout ======');
    const preOrderInput = document.querySelector('pre-order-input');
    
    // stop if can not find preorder input
    if(!preOrderInput) return;

    // open popup
    preOrderInput.style.display = "block";
    return;
  } 
  if(window.location.href.includes('/cart')) {
    e.target.setAttribute('type', 'submit');
  }

})